import axios from '@/api/axios'

export default {
    /* 批量获取字典 */
    getDictionary: (params) => axios.post('/b/base/v1/dict/data/getDictList', params),

    /* 获取行业 */
    getIndustry: (params) => axios.get('/b/base/v1/industry', { params }),

    /* 获取省市城市 */
    getProvinceCity: (params) => axios.get('/b/base/v1/provinceCity', { params }),

    /* OSS上传获取目录 */
    getOssSts: (params) => axios.get('/b/base/v1/oss/sts', { params }),

    /* 营业执照识别 */
    getLicenseInfo: (params) => axios.get('/b/base/v1/licenseInfo', { params }),

    /* 文档解析 */
    getAnalyzeText: (params) => axios.post('/b/base/saas/analyze/text', params),

    /* 注册企业 */
    companyRegister: (params) => axios.post('/b/company/saas/company/register/two', params),

    /* 登出 */
    logout: (params) => axios.post('/b/company/saas/account/logout', params),
}
